import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactElement<any> | number | string;
}

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const FullPageModal = ({ isOpen, onClose, children }: ModalProps) => {
  return (
    <Transition appear show as={Fragment}>
      <Dialog as="div" className="border" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-50"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-50"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 z-20 bg-white" />
        </Transition.Child>

        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="relative flex min-h-full justify-center text-center">
            <Dialog.Panel className="relative w-full max-w-xl transform overflow-auto rounded-md bg-white p-6 text-left align-middle transition-all">
              <div className="w-full">{children}</div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default FullPageModal;
